module.exports = __webpack_public_path__ + "static/media/6209994.97da302f.svg";